/**
 * Copy the displayed BACS account number without changing WooCommerce output.
 *
 * @since 2.38.0
 */
function rtBankAccountClipboard() {
   if (typeof rtBankAccount === 'undefined') {
      return;
   }

   function fallbackCopy(value) {
      const focused = document.activeElement;
      const input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);

      try {
         input.select();
         input.setSelectionRange(0, input.value.length);
         return document.execCommand('copy');
      } finally {
         input.remove();
         if (focused && typeof focused.focus === 'function') {
            focused.focus({ preventScroll: true });
         }
      }
   }

   function setButtonIcon(button, copied) {
      const icon = button.querySelector('.rt-bank-account__icon');
      if (!icon) {
         return;
      }

      icon.innerHTML = copied
         ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/></svg>'
         : '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/></svg>';
   }

   document.querySelectorAll('.wc-bacs-bank-details .account_number').forEach((row) => {
      const number = row.querySelector('strong');
      if (!number || !number.textContent.trim() || row.querySelector('.rt-bank-account__copy')) {
         return;
      }

      const button = document.createElement('button');
      const icon = document.createElement('span');
      const label = document.createElement('span');
      button.type = 'button';
      button.className = 'js-bank-account-copy rt-bank-account__copy';
      button.setAttribute('aria-label', rtBankAccount.label);
      icon.className = 'rt-bank-account__icon rt-icon';
      icon.setAttribute('aria-hidden', 'true');
      label.textContent = rtBankAccount.copy;
      button.appendChild(icon);
      button.appendChild(label);
      setButtonIcon(button, false);
      row.appendChild(button);

      button.addEventListener('click', async () => {
         button.disabled = true;
         const value = number.textContent.trim();

         try {
            if (navigator.clipboard && window.isSecureContext) {
               try {
                  await navigator.clipboard.writeText(value);
               } catch (error) {
                  if (!fallbackCopy(value)) {
                     throw error;
                  }
               }
            } else if (!fallbackCopy(value)) {
               throw new Error('Clipboard unavailable');
            }
            button.classList.add('is-copied');
            button.setAttribute('aria-label', rtBankAccount.success);
            setButtonIcon(button, true);
            window.clearTimeout(button.copyResetTimer);
            button.copyResetTimer = window.setTimeout(() => {
               button.classList.remove('is-copied');
               button.setAttribute('aria-label', rtBankAccount.label);
               setButtonIcon(button, false);
            }, 1800);
         } catch (error) {
            button.classList.add('is-error');
            button.setAttribute('aria-label', rtBankAccount.error);
            window.clearTimeout(button.copyResetTimer);
            button.copyResetTimer = window.setTimeout(() => {
               button.classList.remove('is-error');
               button.setAttribute('aria-label', rtBankAccount.label);
            }, 1800);
         } finally {
            button.disabled = false;
         }
      });
   });
}

if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', rtBankAccountClipboard);
} else {
   rtBankAccountClipboard();
}
